export default "__VITE_ASSET__BJZmjyCt__"